"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState, } from "react";
import DoctorSettingsDialog from "@/components/DoctorSettingsDialog";
const DoctorSettingsContext = createContext(null);
export function DoctorSettingsProvider({ children }) {
    const [open, setOpen] = useState(false);
    const openSettings = useCallback(() => setOpen(true), []);
    const value = useMemo(() => ({ openSettings }), [openSettings]);
    return (_jsxs(DoctorSettingsContext.Provider, { value: value, children: [children, _jsx(DoctorSettingsDialog, { open: open, onOpenChange: setOpen })] }));
}
export function useDoctorSettings() {
    const ctx = useContext(DoctorSettingsContext);
    return ctx !== null && ctx !== void 0 ? ctx : { openSettings: () => { } };
}
